class CustomPermissionModalController {

    constructor(
        UserHelper,
        CustomPermissionModalService
    ) {
        'ngInject'

        this.UserHelper = UserHelper;
        this.CustomPermissionModalService = CustomPermissionModalService;
    }

    $onInit() {
        this.user = this.resolve.user;
        this.permissionList = this.resolve.permissionList;
        this.permissionList.map((p) => p.isSet = this.user.custom_permission_ids.indexOf(p.id) > -1);

        this.clientPermissionIds =  this.UserHelper.getClientPermissions(this.user).map((p) => p.id);
    }

    closeModal() {
        this.modalInstance.close();
    }

    togglePermission(permission) {
        permission.isSet = !permission.isSet;
    }

    saveModal() {
        const setPermissions = this.permissionList.filter((p) => p.isSet);
        let setPermissionIds = setPermissions.map((p) => p.id);
        setPermissionIds = setPermissionIds.concat(this.clientPermissionIds);

        this.CustomPermissionModalService.updateUser(this.user.id,
                                                     setPermissionIds)
            .then((successResponse) => {
                this.modalInstance.close()
            })
    }

}

export default CustomPermissionModalController;


// WEBPACK FOOTER //
// ./app/components/user-admin/custom-permission-modal/custom-permission-modal-controller.js